export default __webpack_public_path__ + "static/media/030_corner_bad.a5dffad8.mp3";